module.exports = __webpack_public_path__ + "img/navigate.ec88eb46.png";